import React from 'react';
import { Table } from '../../../components/table/Table';
import { TableHeader } from '../../../components/table/Headers';

export const LeadCaptureTable = () => {

  return (
    <Table
      api={`/leadcaptures`}
      fields={{
        name: 1,
        email: 1,
        mobile: 1,
        requirement: 1,
        city: 1,
        revenue: 1,
        salesType: 1,
      }}
      renderHeader={() => (
        <TableHeader
          title="Lead Capture"
        />
      )}
      columns={[
        {
          type: 'text',
          field: 'name',
          header: 'Name',
          width: 150,
        },
        {
          type: 'text',
          field: 'email',
          header: 'Email',
          align: 'center',
          width: 275,
        },
        {
          type: 'text',
          field: 'mobile',
          header: 'Phone',
          width: 150,
        },
        {
          type: 'text',
          field: 'city',
          header: 'City',
          width: 120,
          align: 'center',
        },
        {
          type: 'textArea',
          field: 'revenue',
          header: 'Revenue',
        },
        {
          type: 'textArea',
          field: 'salesType',
          header: 'Sales Type',
        },
        {
          type: 'textArea',
          field: 'requirement',
          header: 'Requirement',
        },
      ]}
    />
  );
};
